// extracted by mini-css-extract-plugin
module.exports = {"card":"CampaignCard_card__1E0S_","cardContent":"CampaignCard_cardContent__jS0-W","label":"CampaignCard_label__1TwNB","value":"CampaignCard_value__35hay"};